jQuery(document).ready(function () {

    // scroll to top

    (function () {

        const scrollTop = $('.js-scroll-top');

        scrollTop.click(function () {
            $('body, html').animate({
                scrollTop: 0
            }, 700);
        });

    })();

    // back to Home page from 404

    (function () {
        const pageNotFound = $('.js-page-not-found');

        if (pageNotFound.length) {
            const homepageLocation = pageNotFound.data('homepageLocation');
            const redirectTimeout = pageNotFound.data('redirectTimeout') || 5000;

            setTimeout(function () {
                window.location = homepageLocation;
            }, redirectTimeout);
        }

    })();

    // hover on brands links

    (function () {

        const links = $('.card-brand');

        if (links.length) {

            links.each((index) => {

                links.eq(index).hover(() => {
                   links.eq(index).css('z-index', '12');
                }, () => {
                    setTimeout(() => {
                        links.eq(index).stop().removeAttr('style');
                    }, 800);
                });

            });

        }

    })();

    // show cookies modal

    (function () {

        const pageWrapper = $('.application');

        function showCookies(wrap) {

            if (!$('.js-cookies').length) {
                const cookiesTemplate = $('.js-cookies-template').html()
                wrap.parent().append('<div class="cookies-modal">' + cookiesTemplate + '</div>');

                setTimeout(function () {

                    wrap.addClass('cookies-show');

                }, 2500);
            }

        }

        const chkReadyState = setInterval(function() {

            if (document.readyState === "complete") {

                if (localStorage.getItem('CPCCookies')) {

                    return;

                } else {

                    showCookies(pageWrapper);

                }

                clearInterval(chkReadyState);

            }
        }, 100);

        $(document).on('click', '.cookies-modal__button button', function () {

            pageWrapper.removeClass('cookies-show');

            setTimeout(function () {

                $('.cookies-modal').remove();

                localStorage.setItem('CPCCookies', true);

            }, 800);

        });

    })();

    // smoke animation

    (() => {

        const container = $('.smoke');

        // generate image

        if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {

            function addElement() {
                container.append('<img src="/application/themes/base/assets/images/cover/smoke.png" draggable="false" alt="smoke element"/>')
            }

            // append images to smoke

            for (let i = 0; i < 20; i++) {

                addElement();
            }

        }

    })();

    // section title - copy h2 text to span

    (() => {

        $('.section-title h2').each(function () {
          const self = $(this);
          if (self.find('span').length === 0) {
            self.append('<span>'+ self.html() +'</span>');
          }
        });

    })();

});



// WEBPACK FOOTER //
// ./scripts/general.js